module.exports = __webpack_public_path__ + "4477e3337cd383a78f6cf5f64454e05f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GD.svg
// module id = b3VJ
// module chunks = 0